<div class="pageheader">
    <div class="page-title">
        <h1>Variant versions</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Variant versions log'">
                <app-change-log-link-entity type="VariantVersion"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="container container-fixed">
    <div class="row">
        <div class="col-sm-12">

            <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='variantVersions'
                [bizSetGroupPanel]="false"
                [bizSetColumnChooser]="true"
                [bizSetAllowColumnReordering]="false"
                [bizSetPager]="false"
                (onInitNewRow)="onInitNewRow($event)"
                (onRowInserting)="onRowInserting($event)"
                (onRowUpdating)="onRowUpdating($event)"
                (onRowRemoving)="onRowRemoving($event)"
                [bizEditRowOnDoubleClick]="true">

                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

                <dxo-editing mode="row" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding"
                    [allowDeleting]="allowDeleting"></dxo-editing>

                <dxo-group-panel [visible]="false"></dxo-group-panel>

                <dxi-column dataField="VariantVersionName" caption="Name" dataType="string" width="100%" sortOrder="asc">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="true"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.variantVersions, 'CreatedBy'))"></dxo-header-filter></dxi-column>
                <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="true" format="dateTime"></dxi-column>
                <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.variantVersions, 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
                <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

                <dxi-column type="buttons">
                    <dxi-button name="edit"></dxi-button>
                    <dxi-button name="delete"></dxi-button>
                    <dxi-button text="Show Log"
                                template="logTemplate"
                                [visible]="allowShowLog">
                    </dxi-button>
                </dxi-column>

                <ng-container *dxTemplate="let cell of 'logTemplate'">
                    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.VariantVersionName" [showIcon]="false" classNames="dx-link">
                        <app-change-log-link-entity type="VariantVersion" [id]="cell.data.VariantVersionsId"></app-change-log-link-entity>
                    </app-change-log-link>
                </ng-container>
            </dx-data-grid>

        </div>
    </div>
</div>
